import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app.component';
import { appConfig } from './app/app.config';
import {
  atenderPedidosDeSesion,
  copiarSesionDesdeOpener,
  pedirSesionAOtraPestana,
} from '@core/sesion/session-handoff';

// Antes del bootstrap, y por lo tanto antes de que corra ningún guard.
// Primero el opener (window.open); si no hubo, se le pide a otra pestaña abierta
// (Ctrl+clic, clic del medio, "Abrir en una pestaña nueva").
copiarSesionDesdeOpener();
atenderPedidosDeSesion();

pedirSesionAOtraPestana()
  .then(() => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));
